<template>
  <div class="bank-account">
    <div
      class="bank-account-intro"
    >
      <img
        class="img-logo"
        src="@/assets/images/woori/bank/mzxwooribank.png"
      >
      <p class="title">우리 기업뱅킹
        <br/>이벤트 참여 후
        <br/><span class="highlight-mzc-credit">MZC Credits</span>을
        <br/>받아가세요.
      </p>
      <span class="sub-title">
        메가존클라우드와 우리은행이 다양한 이벤트로
        <span class="line-break"></span>
        MZC Credit을 준비하였습니다.
      </span>
    </div>
    <div
      class="bank-account-content"
    >
      <b-card
        no-body
        class="card-content"
      >
          <div class="title">
            <span>
              EVENT 1
            </span>
            <p>
              우리은행 기업계좌 신규 고객인 경우
              <span class="line-break line-break-event1"></span>
              <span class="highlight-aws-credits">MZC Credits $200</span>를 드립니다
            </p>
          </div>
          <span class="credit-img">
            <img src="@/assets/images/woori/bank/mzc_credit.png">
          </span>
          <b-button
            name="hb_new_account"
            class="btn-show-event"
            @click="handleClickNewAccount"
          >
            계좌 개설 이벤트 보기
          </b-button>
      </b-card>
      <b-card
        no-body
        class="card-content card-content2"
      >
        <div class="title">
          <span>
            EVENT 2
          </span>
          <p>
            우리은행 기업계좌로 AWS 대금 이체 시
            <span class="line-break line-break-event2"></span>
            <span class="highlight-aws-credits">금액의 10%(최대 $200)</span>를
            <span class="line-break line-break-event2"></span>
            MZC Credits으로 드립니다
          </p>
        </div>
        <div class="credit-img d-flex flex-column">
          <span>
            <img src="@/assets/images/woori/bank/mzc_credit_3months.png">
          </span>
          <span class="max-three-months">
            최대 3개월 <span class="highlight-dolloars">$600</span>
          </span>
        </div>
        <b-button
          name="hb_bank_transfer"
          class="btn-show-event"
          @click="handleClickBankTransfer"
        >
          계좌 이체 이벤트 보기
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import useGTag from '@/composables/useGTag'
export default {
    setup (props) {
        const { trackEvent } = useGTag()
        const handleClickNewAccount = () => {
            trackEvent('hb_new_account')
            window.open('https://megareward.megazone.com/?utm_source=hyper_billing&utm_medium=new_account&utm_campaign=new_account', '_blank')
        }
        const handleClickBankTransfer = () => {
            trackEvent('hb_bank_transfer')
            window.open('https://megareward.megazone.com/?utm_source=hyper_billing&utm_medium=bank_transfer&utm_campaign=bank_transfer', '_blank')
        }
        return {
            handleClickNewAccount,
            handleClickBankTransfer
        }
    }
}
</script>

<style>
.bank-account {
  font-family: 'Pretendard', sans-serif;
}
.bank-account-intro {
  padding: 111px 80px;
  font-display: swap;
  letter-spacing: 0%;
  color: #FFFFFF;
  background-image: url('../assets/images/woori/bank/bank_account_main.png'), linear-gradient(107.8deg, #799DE1 0%, #9AB5F8 100.62%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right, bottom;
}
.bank-account-intro .img-logo {
  width: 227.92px;
}
.bank-account-intro .title {
  font-size: 48px;
  line-height: 58px;
  margin: 59px 0;
}
.bank-account-intro .title .highlight-mzc-credit {
  font-weight: 500;
}
.bank-account-intro .sub-title {
  font-size: 24px;
  line-height: 32px;
}
.bank-account-intro .sub-title .line-break {
  display: block;
}
.bank-account-content {
  display: flex;
  justify-content: center;
  background: #DCE7FF;
  padding: 60px 0;
}
.bank-account-content .card-content {
  margin: 0 24px;
  border-radius: 20px;
  box-shadow: 4px 4px 30px 0px #769BE14D;
  padding: 45px 20px;
  text-align: center;
  width: 480px;
  height: 556px;
  background: linear-gradient(127.04deg, #F6F9FF 0%, #FFFFFF 100%);
}
.bank-account-content .card-content {
  display: flex;
  flex-direction: column;
}
.bank-account-content .card-content .title {
  min-height: 175px;
}
.bank-account-content .card-content .credit-img {
  flex-grow: 1;
}
.bank-account-content .card-content .title > span {
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #ACACAC;
  margin-bottom: 18px;
  display: inline-block;
}
.bank-account-content .card-content .title > p {
  font-weight: 400;
  font-size: 23px;
  line-height: 140%;
}
.bank-account-content .card-content .title .highlight-aws-credits {
  font-weight: 600;
  color: #5785DC;
}
.btn-show-event {
  width: 360px;
  height: 60px;
  border-radius: 50px;
  background: #769BE1 !important;
  border: #769BE1 !important;
  font-size: 24px;
  margin: 0 auto;
  font-weight: 200;
}
.btn-show-event:focus {
  background: #769BE1 !important;
}
.max-three-months {
  color: #656565;
  margin-top: 6px;
}
.max-three-months .highlight-dolloars {
  font-weight: 700;
}
.bank-account-content .card-content .line-break.line-break-event1,
.bank-account-content .card-content .line-break.line-break-event2 {
  display: block !important;
}
@media (max-width: 1350px) {
  .bank-account-content .card-content .line-break.line-break-event1,
  .bank-account-content .card-content .line-break.line-break-event2 {
  display: none !important;
}
}
@media (max-width: 981px) {
  .btn-show-event {
    width: 100%;
    height: 60px;
  }
}
/* -------------------- 모바일 스타일 -------------------- */
@media (max-width: 1350px) {
.bank-account-intro {
  padding: 64px 40px;
  background: linear-gradient(107.8deg, #799DE1 0%, #9AB5F8 100.62%);
}
.bank-account-intro .title {
  font-size: 44px;
}
.bank-account-intro .sub-title .line-break {
  display: none;
}
.bank-account-content {
  display: block;
  padding: 56px 0;
}
.bank-account-content .card-content {
  margin: auto;
  padding: 40px 23.5px;
  width: 360px;
  height: 449px;
  margin-bottom: 24px;
}
.bank-account-content .card-content .title {
  min-height: auto;
}
.bank-account-content .card-content.card-content2 {
  height: 516px;
}
.bank-account-content .card-content .title > p {
  margin-bottom: 30px;
  font-size: 20px;
}
.bank-account-content .card-content .line-break {
  display: none;
}
.btn-show-event {
  width: 313px;
  height: 60px;
}
}
</style>
